import type { RefObject } from 'react';

export function getRefElement<T>(element?: RefObject<Element> | T): Element | T | undefined | null {
	if (element != null && typeof element === 'object' && 'current' in element) {
		return element.current;
	}

	return element as T;
}
